import { TablePaginationContent } from '@juvare/common-data-table-ui/DataTable';
import { Box } from '@mui/material';
import React from 'react';
export const VolunteersAdminPagination = (props) => (React.createElement(Box, { sx: { border: 'none', boxShadow: 'none' } },
    React.createElement(TablePaginationContent, Object.assign({}, props))));
